<div class="profiles-table">

  <!-- Title bar -->
  @if (translationPrefix) {
    <div class="profiles-table__title-bar">
      <div class="profiles-table__title-icon">
        <img class="profiles-table__title-icon-img" [src]="iconSrc" alt="" />
      </div>
      <h2 class="profiles-table__title">{{ t('title') | translate }}</h2>
    </div>
  }

  <!-- Header: back button, search, add -->
  <div class="profiles-table__header">
    <div class="profiles-table__left-group">
      <button class="profiles-table__back-button" (click)="back.emit()">
        <p>{{ t('back_to_global_settings') | translate }}</p>
      </button>

      <div class="profiles-table__search">
        <input
          type="text"
          class="profiles-table__search-input"
          [placeholder]="t('search_placeholder') | translate"
          [(ngModel)]="searchQuery"
        />
        <svg class="profiles-table__search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14 14L11.1 11.1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>

    <button class="profiles-table__add-button" (click)="addNew.emit()">
      <span>{{ t('add_new_profile') | translate }}</span>
    </button>
  </div>

  <!-- Table -->
  <div class="profiles-table__table-container">
    <table class="profiles-table__table">
      <thead class="profiles-table__table-header">
        <tr>
          <th class="profiles-table__table-head profiles-table__table-head--name">
            {{ t('table.profile_name') | translate }}
          </th>
          <th class="profiles-table__table-head profiles-table__table-head--orgs">
            {{ t('table.organizations_using') | translate }}
          </th>
          <th class="profiles-table__table-head profiles-table__table-head--default">
            {{ t('table.default_profile') | translate }}
          </th>
          <th class="profiles-table__table-head profiles-table__table-head--actions">
            {{ t('table.actions') | translate }}
          </th>
        </tr>
      </thead>

      <tbody class="profiles-table__table-body">
        @for (profile of filteredProfiles; track profile.uuid; let i = $index) {
          <tr class="profiles-table__table-row" [class.profiles-table__table-row--alt]="i % 2 === 1">

            <!-- Profile Name -->
            <td class="profiles-table__table-cell profiles-table__table-cell--name">
              <p class="profiles-table__name"
                 appTruncateWithTooltip
                 [lineClamp]="2"
                 [maxWidth]="356">{{ profile.name }}</p>
            </td>

            <!-- Count Badge -->
            <td class="profiles-table__table-cell profiles-table__table-cell--orgs">
              <div class="profiles-table__badge">{{ profile.organizationCount }}</div>
            </td>

            <!-- Default Toggle -->
            <td class="profiles-table__table-cell profiles-table__table-cell--default">
              <div class="profiles-table__toggle-wrapper">
                <button
                  class="profiles-table__toggle"
                  [class.profiles-table__toggle--active]="profile.isDefault"
                  (click)="toggleDefault.emit(profile)"
                  [attr.aria-label]="t('toggle_default') | translate">
                  <span class="profiles-table__toggle-thumb"></span>
                </button>
                @if (profile.isDefault) {
                  <div class="profiles-table__default-badge">
                    {{ t('table.default') | translate }}
                  </div>
                }
              </div>
            </td>

            <!-- Actions -->
            <td class="profiles-table__table-cell profiles-table__table-cell--actions">
              <div class="profiles-table__actions">
                <button class="profiles-table__edit-button" (click)="edit.emit(profile)">
                  {{ t('table.edit') | translate }}
                </button>
                <button
                  class="profiles-table__delete-button"
                  (click)="delete.emit(profile)"
                  [disabled]="profile.organizationCount > 0"
                  [attr.aria-label]="t('delete_profile') | translate"
                  [attr.title]="profile.organizationCount > 0 ? (t('delete_disabled_tooltip') | translate) : ''">
                  <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 3.33333H11M9.66667 3.33333V11.6667C9.66667 12.4 9 13 8.33333 13H3.66667C3 13 2.33333 12.4 2.33333 11.6667V3.33333M4.33333 3.33333V2C4.33333 1.26667 5 0.666667 5.66667 0.666667H6.33333C7 0.666667 7.66667 1.26667 7.66667 2V3.33333M5 6V10.3333M7 6V10.3333" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </td>

          </tr>
        }
      </tbody>
    </table>

    <!-- Footer: total count -->
    @if (profiles.length > 0) {
      <div class="profiles-table__footer">
        <p class="profiles-table__footer-text">
          <span class="profiles-table__footer-label">{{ t('footer.total_profiles') | translate }}</span>
          <span class="profiles-table__footer-value">{{ filteredProfiles.length }}</span>
        </p>
      </div>
    }

    <!-- Empty state -->
    @if (filteredProfiles.length === 0) {
      <div class="profiles-table__no-results">
        <p>{{ t('no_results') | translate }}</p>
      </div>
    }
  </div>

</div>
